import { effect, inject, Injectable, Signal } from '@angular/core';
import {
  Dictionary,
  explore,
  Id,
  ReadonlyRepositoryCollectionService,
  Result,
  withFilter,
  withMultiSelect,
  withSearch,
  withSort,
} from '@softline/core';
import { BelegRepository } from '../repositories/beleg.repository';
import { Beleg } from '../types/beleg.model';
import { BelegQueryService } from './beleg-query.service';

@Injectable()
export class BelegService extends ReadonlyRepositoryCollectionService<
  Beleg,
  Result<Beleg[]>,
  Dictionary<unknown>
> {
  private queryService = inject(BelegQueryService);

  override params: Signal<Dictionary<unknown>> = this.queryService.dict;


  explorer = explore(this.all, withSearch(), withFilter(), withSort(), withMultiSelect());

  constructor() {
    super(inject(BelegRepository));
  }

  markAsRead(ids: Id[]): void {
    const all = this.all();
    const updated: Beleg[] = [];
    for (const item of all) {
      const beleg = { ...item };
      if (ids.includes(item.id)) beleg.neuerBeleg = false;
      updated.push(beleg);
    }
    this.all.set(updated);
  }

  protected override getAll(result: Result<Beleg[]> | null | undefined): Beleg[] {
    return result?.result ?? [];
  }
}
